// Features: M004-F0804
// Tests: T-M004-0448
// WebUI #268: the room's service links (Linked Mycelium node) over Core's room service-links routes. Core gates each route on
// rooms_manage in the room's organisation. POST sends exactly { installation_uuid }; nothing else is added here.
// Errors reach the caller unchanged; the panel maps the error code to a sentence and never shows the server message.
// candidates is Core batch G (branch core-room-link-candidates): until it is live the call answers 404 NOT_FOUND.
// getServiceLinksContext is the owner-only fallback for that 404: Core's existing GET /api/v1/service-links/context (human session,
// connected_nodes_manage, SAL 4). Its 401 STEP_UP_REQUIRED is handled by the panel, which retries once.
import api from './api';

const linksPath = (roomId) => `/v1/rooms/${roomId}/service-links`;

export const roomServiceLinksApi = {
  list: async (roomId) => (await api.get(linksPath(roomId))).data.data,
  candidates: async (roomId) => (await api.get(`${linksPath(roomId)}/candidates`)).data.data,
  link: async (roomId, installationUuid) => (await api.post(
    linksPath(roomId),
    { installation_uuid: installationUuid },
  )).data.data,
  unlink: async (roomId, linkId) => (await api.delete(`${linksPath(roomId)}/${linkId}`)).data.data,
  getServiceLinksContext: async () => (await api.get('/v1/service-links/context')).data.data,
};

export default roomServiceLinksApi;
